import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";

import { useSiteContext } from "../../contexts/SiteProvider";
import {
  role_get_select,
  user_get_select,
} from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import { yupResolver } from "@hookform/resolvers/yup";
import { AGENCY_URLS } from "../../api/AdminUrls";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  agency_name: Yup.string()
    .matches(/^\S*$/, "Agency Name cannot contain spaces")
    .required("Agency Name is required"),
  agency_logo: Yup.mixed()
    .required("Agency Logo is required")
    .test(
      "fileType",
      "Only Images are Allowed",
      (value: any) =>
        value && ["image/jpeg", "image/png", "image/gif", "image/webp"].includes(value.type)
    )
    .test(
      "fileSize",
      "File size must be less than 500 KB",
      (value: any) => value && value.size <= 500 * 1024
    ),
  agency_user_id: Yup.object().required(),
});
const AgencyForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });
  const { closeModal } = useSiteContext();

  const [allRole, setAllRole] = useState([]);

  useEffect(() => {
    user_get_select((data: any) => setAllRole(data));
    //role_get_select((data: any) => setAllRole(data));
  }, []);

  const onSubmit = (data: any) => {
    let url = AGENCY_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = dataIn.ID;
      url = AGENCY_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 12,
      name: "agency_name",
      element: {
        label: "Agency Name",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "FILE",
      width: 12,
      name: "agency_logo",
      element: {
        label: "Agency Logo",
        placeHolder: "(Image Only)",
        isRequired: true,
        accept: "image/*",
        // isRequired: true,

        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "SELECT_BOX",
      width: 12,
      name: "agency_user_id",
      element: {
        label: "Select Agency Admin",
        //  inputType: "BORDER_LABEL",
        options: allRole,
        // isMulti: true,
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default AgencyForm;
